import React from "react";
import { format } from "date-fns";
import Tooltip from "../atoms/Tooltip";

interface AuditTooltipProps {
  user?: string;
  timestamp?: Date | string;
  label?: string;
}

const AuditTooltip: React.FC<AuditTooltipProps> = ({ user, timestamp, label }) => {
  if (!user) return <span>—</span>;
  let date: Date | null = null;
  if (timestamp instanceof Date) {
    date = timestamp;
  } else if (typeof timestamp === "string" && timestamp) {
    date = new Date(timestamp);
  } else if ((timestamp as any)?.toDate) {
    date = (timestamp as any).toDate();
  }
  const formatted = date ? format(date, "PPP, p") : "";
  return (
    <Tooltip content={`Created by ${user} on ${formatted}`}>
      <span className="text-xs text-mutedText underline cursor-pointer">{label || user}</span>
    </Tooltip>
  );
};

export default AuditTooltip;
